import React from 'react';
import clsx from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  variant?: 'default' | 'glass';
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  icon,
  variant = 'default',
  className,
  ...props
}) => {
  const baseClasses = 'w-full px-4 py-3 rounded-xl border transition-all duration-200 focus:outline-none focus:ring-4';
  
  const variantClasses = {
    default: 'bg-white/10 backdrop-blur-sm border-white/20 text-white placeholder-white/60 focus:bg-white/15 focus:border-primary-400 focus:ring-primary-300',
    glass: 'bg-white/5 backdrop-blur-md border-white/10 text-white placeholder-white/50 focus:bg-white/10 focus:border-primary-400 focus:ring-primary-300',
  };

  return (
    <div className="w-full">
      {label && (
        <label className="block text-white font-medium mb-2 text-sm">
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-white/60">
            {icon}
          </div>
        )}
        <input
          className={clsx(
            baseClasses,
            variantClasses[variant],
            icon && 'pl-10',
            error && 'border-red-400 focus:border-red-400 focus:ring-red-300',
            className
          )}
          {...props}
        />
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-400">{error}</p>
      )}
    </div>
  );
};
